import React from "react";
import { Box, Typography } from "@mui/material";
import { FONT, NEUTRAL, RADIUS, SHADOW } from "../../styles/brandTokens";

interface SettingsSectionProps {
  id: string;
  title: string;
  description?: React.ReactNode;
  aside?: React.ReactNode;
  children: React.ReactNode;
}

/** A titled card used by every block on the Authorizations tab. */
export default function SettingsSection({ id, title, description, aside, children }: SettingsSectionProps) {
  const headingId = `${id}-heading`;
  return (
    <Box
      component="section"
      aria-labelledby={headingId}
      sx={{
        p: { xs: 2, md: 3 },
        borderRadius: `${RADIUS.card}px`,
        border: `1px solid ${NEUTRAL.border}`,
        background: NEUTRAL.surface,
        boxShadow: SHADOW.card,
      }}
    >
      <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start", justifyContent: "space-between", mb: 2 }}>
        <Box>
          <Typography id={headingId} component="h2" sx={{ fontFamily: FONT.sans, fontSize: "17px", fontWeight: 700, color: NEUTRAL.text }}>
            {title}
          </Typography>
          {description && (
            <Typography sx={{ fontFamily: FONT.sans, fontSize: "14px", color: NEUTRAL.textSecondary, mt: 0.5, maxWidth: 760 }}>
              {description}
            </Typography>
          )}
        </Box>
        {aside}
      </Box>
      {children}
    </Box>
  );
}

export const optionLabelSx = { fontFamily: FONT.sans, fontSize: "14px", color: NEUTRAL.text } as const;
export const optionHintSx = { fontFamily: FONT.sans, fontSize: "12.5px", color: NEUTRAL.textMuted, lineHeight: 1.4 } as const;
export const fieldLabelSx = {
  fontFamily: FONT.sans,
  fontSize: "13px",
  fontWeight: 700,
  color: NEUTRAL.textSecondary,
  mb: 0.75,
} as const;
